import InMoceanDashboard from '../inmocean/components/InMoceanDashboard';

// Project1818 reuses the InMocean shell and CHA-553 page-id vocabulary for the
// demo story; these are UI grant ids, not BigQuery or Firestore tenant ids.
export const PROJECT1818_DEMO_PAGES = [
    'inmocean/home',
    'inmocean/orders',
    'inmocean/production',
    'inmocean/inventory',
    'inmocean/routing-beta',
    'agents',
    'inmocean/workflow',
    'data/target',
];

export function project1818Profile(userProfile) {
    const pages = Array.isArray(userProfile?.pages) && !userProfile.pages.includes('*')
        ? userProfile.pages
        : PROJECT1818_DEMO_PAGES;
    return {
        ...userProfile,
        tenantId: 'project1818',
        pages,
        demoMode: true,
    };
}

export function Project1818Dashboard({ user, userProfile, tenantConfig }) {
    return (
        <InMoceanDashboard
            user={user}
            userProfile={project1818Profile(userProfile)}
            tenantConfig={tenantConfig || project1818TenantConfig}
        />
    );
}

export const project1818TenantConfig = {
    id: 'project1818',

    brand: {
        emoji: '✦',
        title: 'Project1818',
        subtitle: 'Demo Operations Center',
    },

    shellBrand: {
        tenantId: 'project1818',
        name: 'Project1818',
        subtitle: 'DEMO · OPS',
        emoji: '✦',
        logoSrc: null,
    },

    navLabelOverrides: {
        agents: 'Agent (Beta)',
        workflow: 'Work (Beta)',
    },

    demoMode: true,

    AppComponent: Project1818Dashboard,
    tabs: ['dashboard'],

    features: {
        routing: true,
        chainto: false,
    },
};
